/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   getDateValue
 */

import { isMobileDevice } from '@zcode/nr/es/shared/utils/utils'
import { format, isValid as _isValid } from 'date-fns'
import { moveInOptionalValidator } from '../../../../packages/Inputs/validator/moveIn'

// @ts-expect-error
const isValid: (anything: unknown) => anything is Date | number = _isValid

// We currently use Native HTML5 input for Android devices and it expects `YYYY-MM-DD` string for
// its value. For non-android devices, we use DateTime component which expects a date object for
// its value
export const getDateValue = (date: Date | null | undefined) => {
  const isNativePicker = isMobileDevice()

  if (isValid(date) && moveInOptionalValidator.isValidSync(date)) {
    return isNativePicker ? format(date, 'yyyy-MM-dd') : date
  }

  return null
}
